<template>
    <div class="uk-width-1-1 uk-text-right@m">
        <a v-on:click="createAddress()" class="uk-button uk-button-primary uk-width-1-1 uk-width-auto@m">
            {{ $t('rubinred.ecommerce.core.action.add_address') }}
        </a>
    </div>
</template>

<script>
    export default {
      methods: {
        createAddress() {
          window.App.$emit('rubinred.address.create', this);
        }
      }
    }
</script>


// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressAdd.vue